<template>
  <div class="student-application">
    <div class="student-application_header">
      <div class="student-application_header--details">
        <div class="student-application_lists">
          <h3>Student Applications</h3>
          <div class="student-application_lists--card">
            <div class="student-application_lists--card-header">
              <div class="name">
                <h3>David Lines</h3>
                <p>Zero to Hero</p>
              </div>
              <div class="status">
                <p>Status: Final Complete</p>
                <div class="status-indicator">
                  <div class="completed">
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="completed">
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="completed pending">
                    <img src="/static/img/loading.svg" alt="" />
                  </div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <p>Next step: Payment 2</p>
              </div>
            </div>
            <div class="student-application_lists--card-content">
              <div class="date">
                <p>Application Date: 03/10/24</p>
                <p>Start: 03/27/24</p>
                <p>End: 03/27/24</p>
              </div>
              <div class="flow">
                <div class="flow-row">
                  <div class="balance">
                    <p>$110,000.00</p>
                    <span>Tuition Amount</span>
                  </div>
                  <div class="balance">
                    <p>$110,000.00</p>
                    <span>Loan Amount</span>
                  </div>
                  <div class="completed">
                    <p>Student Signature <i class="el-icon-check"></i></p>
                  </div>
                  <div class="completed">
                    <p>School Signature <i class="el-icon-check"></i></p>
                  </div>
                  <div class="completed">
                    <p>Lender Signature <i class="el-icon-check"></i></p>
                  </div>
                  <div>
                    <p>View Full Profile</p>
                  </div>
                </div>
                <div class="flow-row">
                  <div class="active">
                    <p>$28,000.00</p>
                    <span>Payment 1</span>
                  </div>
                  <div class="inactive">
                    <p>$0.00</p>
                    <span>Payment 2</span>
                  </div>
                  <div class="inactive">
                    <p>$0.00</p>
                    <span>Payment 3</span>
                  </div>
                  <div class="inactive">
                    <p>$0.00</p>
                    <span>Payment 4</span>
                  </div>
                  <div class="inactive">
                    <p>$0.00</p>
                    <span>Payment 5</span>
                  </div>
                  <div class="inactive">
                    <p>$0.00</p>
                    <span>Payment 6</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="student-application_lists">
      <h3>Student Applications</h3>
      <div class="student-application_lists--card">
        <div class="student-application_lists--card-header">
          <div class="name">
            <h3>David Lines</h3>
            <p>Zero to Hero</p>
          </div>
          <div class="status">
            <p>Status: Final Complete</p>
            <div class="status-indicator">
              <div class="completed">
                <i class="el-icon-check"></i>
              </div>
              <div class="completed">
                <i class="el-icon-check"></i>
              </div>
              <div class="completed pending">
                <i class="el-icon-loading"></i>
              </div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p>Next step: Payment 2</p>
          </div>
        </div>
        <div class="student-application_lists--card-content">
          <div class="date">
            <p>Application Date: 03/10/24</p>
            <p>Start: 03/27/24</p>
            <p>End: 03/27/24</p>
          </div>
          <div class="flow">
            <div class="flow-row">
              <div class="balance">
                <p>$110,000.00</p>
                <span>Tuition Amount</span>
              </div>
              <div class="balance">
                <p>$110,000.00</p>
                <span>Loan Amount</span>
              </div>
              <div class="completed">
                <p>Student Signature <i class="el-icon-check"></i></p>
              </div>
              <div class="completed">
                <p>School Signature <i class="el-icon-check"></i></p>
              </div>
              <div class="completed">
                <p>Lender Signature <i class="el-icon-check"></i></p>
              </div>
              <div>
                <p>View Full Profile</p>
              </div>
            </div>
            <div class="flow-row">
              <div class="active">
                <p>$28,000.00</p>
                <span>Payment 1</span>
              </div>
              <div class="inactive">
                <p>$0.00</p>
                <span>Payment 2</span>
              </div>
              <div class="inactive">
                <p>$0.00</p>
                <span>Payment 3</span>
              </div>
              <div class="inactive">
                <p>$0.00</p>
                <span>Payment 4</span>
              </div>
              <div class="inactive">
                <p>$0.00</p>
                <span>Payment 5</span>
              </div>
              <div class="inactive">
                <p>$0.00</p>
                <span>Payment 6</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
.student-application {
  &_header {
    display: flex;
    align-items: center;
    gap: 50px;
    align-self: stretch;

    &--logo {
      height: 150px;
      width: 150px;
      border-radius: 10px;

      img {
        width: 100%;
        height: auto;
      }
    }

    &--details {
      display: grid;
      gap: 10px;

      h2 {
        color: #404040;
        text-overflow: ellipsis;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 80px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0;
      }

      &-data {
        display: flex;
        align-items: center;

        span {
          overflow: hidden;
          color: #404040;
          text-overflow: ellipsis;
          font-family: Helvetica, Arial, sans-serif;
          font-size: 25px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          padding: 0 20px;

          &:not(:last-child) {
            border-right: 1px solid #404040;
          }

          &:first-child {
            padding-left: 0;
          }
        }
      }

      &-actions {
        display: flex;
        gap: 10px;

        button {
          display: flex;
          width: 200px;
          height: 27px;
          max-width: 200px;
          padding: 5px 20px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 5px;
          background: rgba(64, 64, 64, 0.5);
        }
      }
    }
  }

  &--details {
    display: grid;
    gap: 10px;

    h2 {
      color: #404040;
      text-overflow: ellipsis;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 80px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin: 0;
    }

    &-data {
      display: flex;
      align-items: center;

      span {
        overflow: hidden;
        color: #404040;
        text-overflow: ellipsis;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 25px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 0 20px;

        &:not(:last-child) {
          border-right: 1px solid #404040;
        }
      }
    }

    &-actions {
      display: flex;
      gap: 10px;

      button {
        display: flex;
        width: 200px;
        height: 27px;
        max-width: 200px;
        padding: 5px 20px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 5px;
        background: rgba(64, 64, 64, 0.5);
      }
    }
  }

  &_lists {
    @media screen and (min-width: 768px) {
      padding-left: 200px;
    }

    h3 {
      padding-left: 20px;
      color: #404040;
      text-overflow: ellipsis;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-bottom: 15px;
    }

    &--card {
      border-radius: 15px;
      background: #fff;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
      display: flex;
      padding: 10px;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;

      &-header {
        display: flex;

        .name {
          @media screen and (min-width: 768px) {
            width: 838px;
          }

          h3 {
            overflow: hidden;
            color: #404040;
            text-overflow: ellipsis;
            font-family: Helvetica, Arial, sans-serif;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            padding: 0;
            margin: 0;
          }

          p {
            overflow: hidden;
            color: #404040;
            text-overflow: ellipsis;
            font-family: Helvetica, Arial, sans-serif;
            font-size: 25px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-bottom: 0;
          }
        }

        .status {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;

          p {
            overflow: hidden;
            color: #404040;
            text-align: center;
            text-overflow: ellipsis;
            font-family: Helvetica, Arial, sans-serif;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin: 0;
          }

          &-indicator {
            display: flex;
            gap: 20px;

            div {
              width: 20px;
              height: 20px;
              border-radius: 100px;
              background: rgba(64, 64, 64, 0.25);
              position: relative;
              overflow: visible;
              display: flex;
              align-items: center;
              justify-content: center;

              i {
                display: none;
                font-size: 10px;
              }

              &:not(:last-child) {
                &:after {
                  content: "";
                  position: absolute;
                  width: 20px;
                  height: 4px;
                  background: rgba(64, 64, 64, 0.25);
                  right: -20px;
                  top: 50%;
                  margin-top: -1px;
                }
              }

              &.completed {
                background: #3c78ff;

                &:not(:last-child) {
                  &:after {
                    background: #3c78ff;
                  }
                }

                i {
                  display: block;
                  color: #fff;
                }
              }
            }
          }
        }
      }

      &-content {
        width: 100%;

        .date {
          display: flex;

          p {
            overflow: hidden;
            color: #404040;
            text-overflow: ellipsis;
            font-family: Helvetica, Arial, sans-serif;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            padding: 0 10px 0 10px;
            margin: 0;

            &:not(:last-child) {
              border-right: 1px solid #404040;
            }

            &:first-child {
              padding-left: 0;
            }
          }
        }

        .flow {
          width: 100%;
          display: grid;
          gap: 10px;
          margin-top: 10px;

          &-row {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            justify-content: space-between;

            div {
              text-align: center;
              width: calc(100% / 6);

              &.balance {
                p {
                  background: #3c78ff;
                  color: #fff;
                }
              }

              p {
                color: rgba(64, 64, 64, 0.75);
                text-align: center;
                text-overflow: ellipsis;
                font-family: Helvetica, Arial, sans-serif;
                font-size: 15px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                border-radius: 5px;
                background: rgba(64, 64, 64, 0.1);
                height: 27px;
                width: 100%;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;

                i {
                  width: 20px;
                  height: 20px;
                  border-radius: 100px;
                  background: #3c78ff;
                  color: #fff;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 10px;
                }
              }

              span {
                overflow: hidden;
                color: rgba(64, 64, 64, 0.5);
                text-overflow: ellipsis;
                font-family: Helvetica, Arial, sans-serif;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                display: block;
              }

              &.inactive {
                p {
                  border: 1px solid #ddd;
                  background: none;
                  color: rgba(64, 64, 64, 0.35);
                }
              }

              &.active {
                p {
                  background: #00b345;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
